// reducers/employee-onboarding/list.js

// list

export function listHasErrored(state = false, action) {
  switch (action.type) {
    case 'ONBOARDING_LIST_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function listIsLoading(state = false, action) {
  switch (action.type) {
    case 'ONBOARDING_LIST_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function list(state = [], action) {
  switch (action.type) {
    case 'ONBOARDING_LIST_FETCH_DATA_SUCCESS':
      return action.list;
    default:
      return state;
  }
}

// listGroups

export function listGroupsHasErrored(state = false, action) {
  switch (action.type) {
    case 'ONBOARDING_LIST_GROUPS_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function listGroupsIsLoading(state = false, action) {
  switch (action.type) {
    case 'ONBOARDING_LIST_GROUPS_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function listGroups(state = [], action) {
  switch (action.type) {
    case 'ONBOARDING_LIST_GROUPS_FETCH_DATA_SUCCESS':
      return action.data;
    default:
      return state;
  }
}